export default __webpack_public_path__ + "static/media/corrective-action.895f4b90.svg";